export const ChargifyState = {
	url: '/chargify',
	template: '<view-chargify-page></view-chargify-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "viewChargifyPageMod" */
			'@Containers/view-chargify-page/view-chargify-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
